export const organisationServiceAreas = {
    col: "City Of London",
    hackney: "Hackney",
    other: "Other"
  };
  